/**
 * Cópia profunda do payload antes de guardá-lo no state.
 *
 * POR QUE EXISTE
 * As mutations do módulo faziam `JSON.parse(JSON.stringify(payload))` inline —
 * 16 cópias da mesma linha. Uma função nomeada diz o PORQUÊ (não guardar
 * referência viva do que veio da camada de API, senão um consumidor mutando o
 * objeto altera o store pelas costas) e concentra a decisão num lugar só.
 *
 * POR QUE NÃO `structuredClone`
 * O SonarQube sugere trocar (`javascript:S7784`). Medido antes de decidir:
 *
 *   $ npx browserslist
 *   chrome 90, chrome 91, chrome 92, bb 7, bb 10, and_uc 12.12, baidu 7.12, ...
 *
 * `structuredClone` só existe a partir do Chrome 98 — e é API de RUNTIME, que
 * o Babel não transpila e o core-js não preenche. Nesses alvos a chamada
 * lançaria `ReferenceError` em produção.
 *
 * Há ainda uma divergência de comportamento que importa aqui: `structuredClone`
 * preserva `Date` como `Date`, o `JSON` converte para string ISO. O módulo
 * ainda roda com APIs mockadas que constroem `new Date()`, então a troca
 * mudaria silenciosamente o tipo que chega nas telas.
 *
 * O `CLAUDE.md` do repo também prescreve este mesmo par para deep clone.
 */
export function clonarPayload(payload) {
  return JSON.parse(JSON.stringify(payload))
}

export default clonarPayload
